import { calculatePmsHealthCheckRowStatus } from './calculatePmsHealthCheckRowStatus'

/**
 * Counts PMS sync summary buckets from row status (alert / warning / green).
 * Sync OK uses green only so stale-sync critical rows are not counted as OK.
 */
export function buildPmsTableSyncSummary(rows) {
  let green = 0
  let warning = 0
  let alert = 0

  for (const row of rows) {
    const status = calculatePmsHealthCheckRowStatus(row)
    if (status === 'green') {
      green += 1
    } else if (status === 'warning') {
      warning += 1
    } else if (status === 'alert') {
      alert += 1
    }
  }

  return {
    total: rows.length,
    green,
    warning,
    alert,
    notWorking: warning + alert
  }
}
